module.exports = __webpack_public_path__ + "img/side_bg1.1f6a4ad5.png";